import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskReportsSatisfactionIssueRoute: InvariantJiraRoute = {
	name: 'servicedesk-reports-satisfaction-time-scale-issue',
	path: '/jira/servicedesk/projects/:projectKey/reports/all-rating/timescale/:timescaleId/:issueKey',
	query: ['oldIssueView?'],
	exact: true,
};
